export const GetGraphImagePath = imageData => {
  const url = typeof window !== 'undefined' ? window.location.origin : '';

  return url + imageData?.childImageSharp?.gatsbyImageData.images.fallback.src;
};

export const GetGraphUrl = (): string =>
  typeof window !== 'undefined' ? window.location.href : '';
